/* eslint-disable  */

// ** Icons Import
import {
  Box,
  Mail,
  User,
  Circle,
  Shield,
  Calendar,
  FileText,
  CheckSquare,
  ShoppingCart,
  MessageSquare,
  Square,
} from "react-feather";

export default [
  {
    id: "apps",
    title: "Apps",
    icon: <Box />,
    children: [
      {
        id: "Create Invoice",
        title: "Create Invoice",
        icon: <FileText size={20} />,
        navLink: "/apps/invoiceCreate",
      },
      {
        id: "order",
        title: "Order",
        icon: <User />,
        children: [
          {
            id: "list",
            title: "List",
            icon: <Circle />,
            navLink: "/apps/order/list",
          },
          {
            id: "salesPiplineList",
            title: "SalesPiplineList",
            icon: <Circle />,
            navLink: "/apps/order/salesPipline/list",
          },
        ],
      },
      {
        id: "labels",
        title: "Labels",
        icon: <User />,
        children: [
          {
            id: "list",
            title: "List",
            icon: <Circle />,
            navLink: "/apps/labels/list",
          },
        ],
      },
      {
        id: "state",
        title: "State",
        icon: <User />,
        children: [
          {
            id: "list",
            title: "List",
            icon: <Circle />,
            navLink: "/apps/state/list",
          },
        ],
      },
      {
        id: "saleManagerManagement",
        title: "SaleManager",
        icon: <User />,
        children: [
          {
            id: "list",
            title: "List",
            icon: <Circle />,
            navLink: "/apps/saleManagerManagement/list",
          },
        ],
      },
      {
        id: "depot",
        title: "Depot",
        icon: <User />,
        children: [
          {
            id: "list",
            title: "List",
            icon: <Circle />,
            navLink: "/apps/depot/list",
          },
        ],
      },
      {
        id: "inventory",
        title: "inventory",
        icon: <User />,
        children: [
          {
            id: "inventoryFolder",
            title: "InventoryFolder",
            icon: <Circle />,
            navLink: "/apps/inventoryFolder/list",
          },
          {
            id: "inventoryItem",
            title: "inventoryItem",
            icon: <Circle />,
            navLink: "/apps/inventoryItem/list",
          },
        ],
      },

      {
        id: "users",
        title: "User",
        icon: <User />,
        children: [
          {
            id: "list",
            title: "List",
            icon: <Circle />,
            navLink: "/apps/user/list",
          },
        ],
      },
      {
        id: "containers",
        title: "Containers",
        icon: <User />,
        children: [
          {
            id: "list",
            title: "List",
            icon: <Circle />,
            navLink: "/apps/container/list",
          },
        ],
      },
      {
        id: "commission",
        title: "Commission",
        icon: <User />,
        children: [
          {
            id: "commissionsByRole",
            title: "By Role",
            icon: <Circle />,
            navLink: "/apps/commissionsByRole/list",
          },
          {
            id: "commissions",
            title: "Commissions",
            icon: <Circle />,
            navLink: "/apps/commissions/list",
          },
        ],
      },
      {
        id: "discount",
        title: "Discount",
        icon: <User />,
        children: [
          {
            id: "list",
            title: "List",
            icon: <Circle />,
            navLink: "/apps/discount/list",
          },
        ],
      },

      {
        id: "Ranking",
        title: "Ranking",
        icon: <User />,
        children: [
          {
            id: "list",
            title: "List",
            icon: <Circle />,
            navLink: "/apps/rankingAgent/list",
          },
          {
            id: "list",
            title: "List",
            icon: <Circle />,
            navLink: "/apps/rankingAssistant/list",
          },
        ],
      },

      {
        id: "email",
        title: "Email",
        icon: <User />,
        children: [
          {
            id: "setting",
            title: "Setting",
            icon: <Circle />,
            navLink: "/apps/email/setting/list",
          },
          {
            id: "emailStatic",
            title: "Email Static",
            icon: <Circle />,
            navLink: "/apps/email/static/list",
          },
          {
            id: "emailTemplete",
            title: "Email Templete",
            icon: <Circle />,
            navLink: "/apps/email/templete/list",
          },
        ],
      },
    ],
  },
];
